import React from 'react';
import { LayoutGrid, LayoutList } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ViewSwitch = ({ isCardView, onViewChange }) => {
  const { t } = useTranslation();

  // Hide the component completely on small screens
  return (
    <div className="hidden sm:flex bg-gray-100 p-1 rounded-lg space-x-1">
      <button
        onClick={() => onViewChange(true)}
        className={`p-1.5 rounded flex items-center space-x-1 ${
          isCardView
            ? 'bg-white text-blue-600 shadow'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        title={t('common.views.cardView', 'Card view')}
      >
        <LayoutGrid className="h-4 w-4" />
        <span className="text-xs">{t('common.views.cards', 'Cards')}</span>
      </button>
      <button
        onClick={() => onViewChange(false)}
        className={`p-1.5 rounded flex items-center space-x-1 ${
          !isCardView
            ? 'bg-white text-blue-600 shadow'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        title={t('common.views.tableView', 'Table view')}
      >
        <LayoutList className="h-4 w-4" />
        <span className="text-xs">{t('common.views.table', 'Table')}</span>
      </button>
    </div>
  );
};

export default ViewSwitch;